<div class="mfa-setup-step">
  <!-- Sub-stap 1/3 -->
  <ng-container *ngIf="subStep === 1">
    <h3>2-stapsverificatie instellen</h3>
    <p>
      Organisatie <strong>{{ enforcingOrgName }}</strong> vereist 2-stapsverificatie voor alle gebruikers. Je moet dit eerst instellen voor je verder kunt.
    </p>
    <p>
      2-stapsverificatie is een extra beveiligingslaag bovenop je wachtwoord: bij elke aanmelding voer je een code in die je authenticator-app op je smartphone genereert. Zo kan iemand met enkel je wachtwoord niet inloggen.
    </p>
    <p>Het instellen duurt ongeveer 2 minuten. Je hebt je smartphone nodig.</p>
    <div class="actions">
      <app-button (click)="next()" [name]="'Volgende'"></app-button>
    </div>
  </ng-container>

  <!-- Sub-stap 2/3 -->
  <ng-container *ngIf="subStep === 2">
    <h3>Stap 1 — Installeer een authenticator-app</h3>
    <p>Heb je al een authenticator-app op je telefoon? Dan kan je direct verder.</p>
    <p>Heb je er nog geen? Installeer dan <strong>Google Authenticator</strong> of <strong>Microsoft Authenticator</strong> — beide werken even goed.</p>
    <table class="app-links">
      <thead><tr><th>App</th><th>iOS</th><th>Android</th></tr></thead>
      <tbody>
        <tr>
          <td>Google Authenticator</td>
          <td><a href="https://apps.apple.com/nl/app/google-authenticator/id388497605" target="_blank" rel="noopener">App Store</a></td>
          <td><a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=nl" target="_blank" rel="noopener">Google Play</a></td>
        </tr>
        <tr>
          <td>Microsoft Authenticator</td>
          <td><a href="https://apps.apple.com/nl/app/microsoft-authenticator/id983156458" target="_blank" rel="noopener">App Store</a></td>
          <td><a href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=nl" target="_blank" rel="noopener">Google Play</a></td>
        </tr>
      </tbody>
    </table>
    <div class="actions">
      <app-button (click)="previous()" [name]="'Vorige'" [buttonClass]="'btn btn-secondary'"></app-button>
      <app-button (click)="next()" [name]="'Volgende'" [isSaving]="isLoading"></app-button>
    </div>
    <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
  </ng-container>

  <!-- Sub-stap 3/3 -->
  <ng-container *ngIf="subStep === 3 && setupCode">
    <h3>Stap 2 — Scan de QR-code</h3>
    <p>Open je authenticator-app, kies <em>"Account toevoegen"</em> of <em>"+"</em>, en scan onderstaande QR-code.</p>
    <div class="qr">
      <img [src]="setupCode.QrCodeSetupImageUrl" alt="QR-code voor 2-stapsverificatie" />
    </div>
    <p>Lukt scannen niet? Voer dan deze sleutel handmatig in je authenticator-app in:</p>
    <div class="manual-key">
      <code>{{ setupCode.ManualEntryKey }}</code>
    </div>
    <p>Vul daarna de 6-cijferige code in die je in de app ziet:</p>
    <app-horizontal-text-input [control]="code" label="Code"></app-horizontal-text-input>
    <div class="actions">
      <app-button (click)="previous()" [name]="'Vorige'" [buttonClass]="'btn btn-secondary'"></app-button>
      <app-button (click)="submitCode()" [name]="'Bevestigen'" [isSaving]="isLoading"></app-button>
    </div>
    <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
  </ng-container>
</div>
